module.exports = __webpack_public_path__ + "img/087.c0fb0edb.jpg";